export const useGeneralStore = defineStore('general', () => {
    //template ref set temporary DOM element
    const email = ref(null);

    return {
        email
    };
});
